import { HttpClient } from "@angular/common/http";
import { AccountService } from "./account.service";
import { SCAMP_API, APP_SETTINGS } from "src/environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class EquipamentoService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos`, {
            headers: this.account.composeHeaders(),
        });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/${id}`, {
            headers: this.account.composeHeaders(),
        });
    }
    getByIdOrNSerie(identificador) {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/por-identificador/${identificador}`, { headers: this.account.composeHeaders() });
    }
    getByIdOrNSerieSumary(identificador) {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/por-identificador-resumo/${identificador}`, { headers: this.account.composeHeaders() });
    }
    getEquipamentosForComboBox() {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/para-combobox`, { headers: this.account.composeHeaders() });
    }
    post(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/equipamentos`, data, {
            headers: this.account.composeHeaders(),
        });
    }
    getPlanoManutencaoExcel(equipamentosIds, anoProximaExecucao) {
        return this.http.post(`${SCAMP_API.accountApiV1}/equipamentos/plano-manutencao`, { equipamentosIds, anoProximaExecucao }, { headers: this.account.composeHeaders() });
    }
    nomeJaCadastrado(nome) {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/nome-nao-cadastrado/${nome}`, { headers: this.account.composeHeaders() });
    }
    numeroSerieJaCadastrada(numeroserie) {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/numeroserie-nao-cadastrada/${numeroserie}`, { headers: this.account.composeHeaders() });
    }
    getEquipamentosPorLocalId(localId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/equipamentos/por-local/${localId}`, { headers: this.account.composeHeaders() });
    }
    delete(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/equipamentos/${id}`, {
            headers: this.account.composeHeaders(),
        });
    }
    busca(parameter) {
        parameter.tipoLocal = APP_SETTINGS.tipoLocal;
        return this.http.post(`${SCAMP_API.accountApiV1}/equipamentos/busca`, parameter, { headers: this.account.composeHeaders() });
    }
}
EquipamentoService.ngInjectableDef = i0.defineInjectable({ factory: function EquipamentoService_Factory() { return new EquipamentoService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: EquipamentoService, providedIn: "root" });
